import React from 'react'
import Seminars from '../../components/Seminars'

const Room = ({
  isFetchingRooms,
  isFetchingConferenceDetails,
  conferenceDetails,
  ...rest
}) => (
  <div className="w-100 flex">
    <div
      style={{ width: '100%' }}
    >
      <Seminars
       emailAddressBook={rest.emailAddressBook} 
       groups={rest.groups} 
       fetchEmailAddressBook={rest.fetchEmailAddressBook} 
       fetchGroups={rest.fetchGroups}  
       pathname={rest.location.pathname} 
       history={rest.history} 
      />
    </div>
  </div>
)

export default Room



// WEBPACK FOOTER //
// src/routes/Room/Room.js